import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import Grid from '@material-ui/core/Grid';

import Cache from './Cache';

import RelatorioService from '../../services/Relatorio';
import { errors } from '../../services/API';

import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";
import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import Loading from '../../components/Loading/Loading';
import Filters from '../../components/Filters/Filters';

import DadosMunicipios from '../../forms/Relatorio/DadosMunicipios';
import { ButtonExport } from '../../forms/Buttons/ButtonsExport';
import DependenciaAdministrativaFilter from '../../forms/DependenciaAdministrativa/DependenciaAdministrativaFilter';

import { isAdministradorOuCentral } from '../../security/AuthorizedFunction';

import { download } from '../../helper/FileHelper';

import { Layout } from '../../layouts/private/Private';

export class Municipios extends Component {
    constructor(props) {
        super(props);
        this.state = {
            municipios: [],
            ultimaChamada: '',
            loading: true,
        }
    }

    // DECLARAÇÃO DE REFERÊNCIA DOS COMPONENTES
    setToast = t => this.Toast = t;
    setDependenciaAdministrativaFilter = d => this.DependenciaAdministrativaFilter = d;

    // EXPORTAÇÃO
    handleExportChange = () => {
        const f = [];
        const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

        if (filtersDepAdm.adminDep) f.push({ field: 'depAdmin', value: filtersDepAdm.adminDep })

        f.push({ field: "forceRefresh", value: true })
        f.push({ field: 'exportarPlanilha', value: true });
        
        this.Toast.setState({
            message: {
                message: "A Planilha está sendo gerada para Exportação.",
                type: 'info',
                open: true,
                loading: true,
                autoHide: false,
            }
        })

        RelatorioService.exportReportMunicipiosResidenciais(f)
            .then(res => download(res))
    }

    // FILTROS
    ApplyFilters = () => {
        this.setState({ loading: true });

        const f = [];
        const filtersDepAdm = this.DependenciaAdministrativaFilter.state.filters;

        if (filtersDepAdm.adminDep) f.push({ field: 'depAdmin', value: filtersDepAdm.adminDep })

        f.push({ field: "forceRefresh", value: true })

        RelatorioService.filtersReportMunicipiosResidenciais(f)
            .then(res => {
                this.setState({ 
                    municipios: [...res.data.cache],
                    ultimaChamada: res.data.ultimaChamadaFormatada,
                    loading: false,
                });
            })
            .catch(error => {
                const e = errors(error);
                this.setState({ loading: false });
                
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
    }

    // LIMPAR FILTROS
    handleFilterClear = () => {
        this.DependenciaAdministrativaFilter.setState({
            filters: {
                adminDep: '',
            }
        })
    }

    buscarMunicipios = (forceRefresh = false) => {
        this.setState({ loading: true });
        const filters = [{ 'field': "forceRefresh", 'value': forceRefresh }];

        RelatorioService.filtersReportMunicipiosResidenciais(filters)
            .then(res => {
                this.setState({ 
                    municipios: [...res.data.cache],
                    ultimaChamada: res.data.ultimaChamadaFormatada,
                    loading: false 
                });
            })
            .catch(error => {
                const e = errors(error);
                this.setState({ loading: false });
                
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                })
            })
    }

    componentDidMount() {
        this.props.loadPeriodos();
        this.buscarMunicipios();
    }

    render() {
        const pageName = 'Municípios Residenciais';
        const links = [
            { 
                path: null, 
                name: 'Relatórios' 
            }
        ];

        return(
            <Layout>
                <Toast parentRef={this.setToast} />
                <Grid container >
                    <Grid item xs={12}>
                        <Breadcrumbs links={links} active={pageName} />
                    </Grid>
                </Grid>
                <Title>
                    {pageName}
                    { this.state.ultimaChamada && 
                        <Cache ultimaAtualizacao={this.state.ultimaChamada} action={() => this.buscarMunicipios(true)} /> 
                    }
                </Title>

                <Filters
                    handleFilter={this.ApplyFilters}
                    handleFilterClear={this.handleFilterClear}
                >
                    <Grid item container spacing={3}>
                        <DependenciaAdministrativaFilter
                            parentRef={this.setDependenciaAdministrativaFilter}
                            withPublicGroup={true}
                        />
                    </Grid>
                </Filters>
                <Grid container >
                    { isAdministradorOuCentral() && 
                        <ButtonExport
                            title="Exportar Planilha"
                            onClick={this.handleExportChange}
                        />
                    }
                </Grid>

                { this.state.loading ? 
                    <Loading />
                :
                    <DadosMunicipios municipios={this.state.municipios} contexts={this.props.contexts} />
                }
            </Layout>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Municipios));